import React from "react";
import { Copy, ExternalLink, Link2 } from "lucide-react";
import { toast } from "sonner";
import { segSlug } from "@/pages/WatchSegmentPage";

const copy = (url) => navigator.clipboard.writeText(url).then(() => toast.success("Link copied")).catch(() => toast.error("Couldn't copy — select the link and copy it"));

/** Public no-login link for every segment: copy it or open it in a new tab. */
export default function PublicLinks({ segments }) {
  const base = `${window.location.origin}/watch/`;
  return (
    <section className="space-y-2" data-testid="showcase-public-links">
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-nex-gold"><Link2 className="h-3.5 w-3.5" /> Public links · no login needed</div>
      <div className="border border-white/10 divide-y divide-white/5">
        {segments.map((s) => {
          const url = base + segSlug(s.title);
          return (
            <div key={s.n} data-testid={`showcase-link-${s.n}`} className="flex items-center gap-3 px-3 py-2 hover:bg-white/[0.02] transition-colors">
              <span className="font-serif text-lg text-nex-gold/70 w-7 shrink-0">{String(s.n).padStart(2, "0")}</span>
              <span className="min-w-0 flex-1">
                <span className="block text-sm text-nex-silver font-semibold">{s.title}</span>
                <span data-testid={`showcase-link-url-${s.n}`} className="block font-mono text-[11px] text-nex-muted break-all select-all">{url}</span>
              </span>
              <button type="button" onClick={() => copy(url)} data-testid={`showcase-link-copy-${s.n}`} title="Copy link" className="shrink-0 inline-flex items-center gap-1 border border-white/15 px-2 py-1 text-xs text-nex-silver hover:border-nex-gold/50 hover:text-nex-gold transition-colors"><Copy className="h-3 w-3" /> Copy</button>
              <a href={url} target="_blank" rel="noopener noreferrer" data-testid={`showcase-link-open-${s.n}`} title="Open in a new tab" className="shrink-0 inline-flex items-center gap-1 border border-nex-gold/40 px-2 py-1 text-xs text-nex-gold hover:bg-nex-gold/10 transition-colors"><ExternalLink className="h-3 w-3" /> Play</a>
            </div>);
        })}
      </div>
      <button type="button" onClick={() => copy(segments.map((s) => `${s.n}. ${s.title} — ${base}${segSlug(s.title)}`).join("\n"))} data-testid="showcase-link-copy-all"
        className="inline-flex items-center gap-1.5 border border-white/15 px-3 py-1.5 text-xs text-nex-silver hover:border-nex-gold/50 hover:text-nex-gold transition-colors"><Copy className="h-3 w-3" /> Copy all 12 links</button>
    </section>
  );
}
